type Operator = "equal" | "different";

export const countBy = <RootEntity, Value>(
	list: Array<RootEntity>,
	selector: (entity: RootEntity) => Value,
	value: Value,
	operator: Operator = "equal"
) =>
	list.reduce((total: number, currentRoot: RootEntity) => {
		const selected = selector(currentRoot);
		const isValueMatched = operator === "equal" ? selected === value : selected !== value;
		return total + Number(isValueMatched);
	}, 0);
